<mat-form-field *ngIf="objets !== undefined && parent" class="full-width" [formGroup]="parent">
  <mat-label>{{libelle}}</mat-label>
    <input type= "text"
      matInput
      [formControlName]="name"
      [placeholder]="'Sélectionner la ' + libelle"
      [matAutocomplete]="auto"
      (change)="$event.target.value === '' ? deleteIfEmpty() : null" required>
  <mat-autocomplete 
    autoActiveFirstOption 
    panelWidth="auto"
    #auto="matAutocomplete" 
    (optionSelected)="onObjetChange($event)">
    <mat-option *ngFor="let obj of filteredObjets | async" [value]="obj"> {{obj}}</mat-option>
  </mat-autocomplete>
  <mat-error *ngIf="myControl.hasError('forbiddenNames')">
    Veuillez sélectionner une valeur suggérée
  </mat-error>
  <mat-error *ngIf="myControl.hasError('required')">
    Veuillez sélectionner une valeur suggérée
  </mat-error>
</mat-form-field>